
<div class="container" *ngIf="enableHighRadius">
  <div class="row">
    <div class="col-sm-12">
      <h2>Credit Request History Report</h2>
      <error [error]="error"></error>
      <div class="alert alert-success" *ngIf="creditReleasedMessages"><span>{{creditReleasedMessages}}</span></div>
      <div class="alert alert-danger" *ngIf="validationMessages"><span>{{validationMessages}}</span></div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="table-card">
        <div class="col" style="max-width: 98%;">
          <div class="row"> 
            <div class="col-md-10">
              <list-controls [pageName]="&quot;creditRequestHistoryReport&quot;" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
            </div>
            <div class="col-md-2">
              <div class="row">
                <div class="col-md-6"> 
                  <button class="btn btn-primary" type="button" title="Release" style="margin-left: -8px;" (click)="release()" *privilege="'credit-check-released'">Release</button>
                </div>
                <div class="col-md-6"> 
                  <button class="btn btn-primary" type="button" title="Export" [downloadFile]="'/api/CreditCheck/export-credit-request-history-file'">Export</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 98%;">
          <form class="row" #projectForm="ngForm" (ngSubmit)="save()">
            <div class="form-group col-sm-2">
              <select class="form-control" id="country" name="country" [(ngModel)]="filter.country" (change)="save()">
                <option [value]="null" selected>All Countries</option>
                <option *ngFor="let country of countries" [value]="country.id">{{ country.value }}</option>
              </select>
            </div>
            <div class="form-group col-sm-2" style="padding-left: 0px;">
              <select class="form-control" id="creditAnalyst" name="creditAnalyst" [(ngModel)]="filter.creditAnalyst" (change)="save()">
                <option [value]="null" selected>Credit Analyst</option>
                <option *ngFor="let data of creditAnalyst" [ngValue]="data.credit_analyst">{{ data.credit_analyst }} </option>
              </select>
            </div>
            <div class="form-group col-sm-2" style="padding-left: 0px;">
              <select class="form-control" id="statue" name="status" [(ngModel)]="filter.status" (change)="save()">
                <option [value]="null" selected>All Status</option>
                <option *ngFor="let data of status" [value]="data.id">{{ data.value }}  </option>
              </select>
            </div>
            <div class="col-sm-5"> 
              <div class="row">
                <div class="row col-sm-10" style="border: 1px solid #ccc;width: 90%;margin-left: 5px;align-items: center;zoom: 0.9;padding-top: 2px;padding-bottom: 2px;">
                  <div class="col-sm-6" style="padding: 0;">
                    <datepicker class="right input-group-append" #creditReportStartDate [(ngModel)]="filter.maStartDate" [value]="filter.maStartDate" showInput="maStartDate" name="maStartDate" placeholder="Start Date"></datepicker>
                  </div>
                  <div class="col-sm-6" style="padding-right: 0;">
                    <datepicker class="right input-group-append" #creditReportEndDate [(ngModel)]="filter.maEndDate" [value]="filter.maEndDate" showInput="maEndDate" name="maEndDate" placeholder="End Date"> </datepicker>
                  </div>
                </div>
                <div class="col-sm-1"> 
                  <button class="btn btn-primary" type="submit" title="Apply Filter">Go           </button>
                </div>
              </div>
            </div>
            <div class="col-sm-1">
              <div class="row"> 
                <div class="col-sm-6"> 
                  <button class="btn btn-primary" type="button" title="Clear Filters" (click)="clearFilter()">Clear</button>
                </div>
              </div>
            </div>
          </form>
          <div *ngIf="loading">
            <md-spinner-block></md-spinner-block>
          </div>
        </div>
      </div>
      <ng-container *ngIf="!loading">
        <div class="table table-responsive">
          <div class="thead-info">
            <div class="table-header-with-controls">
              <div class="col-lg-12 table-header-with-controls" style="margin-bottom: 24px;"> 
                <div class="row"> 
                  <table width="100%">
                    <colgroup>
                      <col style="width:2%">
                      <col style="width:12%">
                      <col style="width:11%">
                      <col style="width:11%">
                      <col style="width:11%">
                      <col style="width:14%">
                      <col style="width:14%">
                      <col style="width:12%">
                      <col style="width:12%">
                      <col style="width:2%;">
                    </colgroup>
                    <thead>
                      <tr>
                        <th> </th>
                        <th>Deal</th>
                        <th>SoldTo BPID</th>
                        <th>Payer BPID</th>
                        <th>Credit Analyst</th>
                        <th>TCV</th>
                        <th>Country</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody class="card-block" *ngFor="let creditCheck of creditCheckList; let idx = index;">
                      <tr>
                        <td> 
                          <input type="checkbox" name="creditCheckBox" [value]="creditCheck.id" (change)="onCheckboxChange($event)" [disabled]="creditCheck.status">
                        </td>
                        <td> 
                          <p style="word-break: break-word;">{{creditCheck.dartDeals}}</p>
                        </td>
                        <td> 
                          <p>{{creditCheck.soldTo}}</p>
                        </td>
                        <td> 
                          <p>{{creditCheck.payerBpId}}</p>
                        </td>
                        <td> 
                          <p style="word-break: break-word;">{{creditCheck.creditAnalyst}}</p>
                        </td>
                        <td> 
                          <p style="word-break: break-word;">{{creditCheck.tcvFormatted}}</p>
                        </td>
                        <td> 
                          <p style="word-break: break-word;">{{creditCheck.country}}</p>
                        </td>
                        <td> 
                          <p>{{getStatus(creditCheck.status)}}</p>
                        </td>
                        <td style="padding: 0.75em 0em;"> <span><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show contract creditCheck details" (click)="toggleExpandedContractAccount(creditCheck.id)" style="padding: 0.5rem; line-height: 1; border-spacing: 0;"><span class="icon oi oi-chevron-bottom" *ngIf="expandedCreditCheckData !== creditCheck.id"></span><span class="icon oi oi-chevron-top" *ngIf="expandedCreditCheckData === creditCheck.id"></span></a></span></td>
                      </tr>
                      <tr *ngIf="expandedCreditCheckData === creditCheck.id">
                        <td colspan="10">
                          <div class="col-lg-12">
                            <div class="row card-block"> 
                              <div class="col-md-6">
                                <div class="row"> 
                                  <div class="col-md-4" style="margin-bottom: 7px"><span><b>SoldTo Name </b></span></div>
                                  <div class="col-md-1"><span><b>: </b></span></div>
                                  <div class="col-md-7"><span style="word-break: break-word;">{{creditCheck.customer}}</span></div>
                                </div>
                                <div class="row" *ngIf="creditCheck.releasedByUser">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Released By User</b></span></div>
                                  <div class="col-md-1"> <span><b>:</b></span></div>
                                  <div class="col-md-7"><span style="word-break: break-word;">{{creditCheck.releasedByUser}}</span></div>
                                </div>
                                <div class="row" *ngIf="creditCheck.creditBlockReason">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Credit Block Reason </b></span></div>
                                  <div class="col-md-1"> <span><b>:</b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.creditBlockReason}}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Currency </b></span></div>
                                  <div class="col-md-1"> <span><b>: </b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.currency}}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Business Type </b></span></div>
                                  <div class="col-md-1"> <span><b>:</b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.businessType}}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Business Model </b></span></div>
                                  <div class="col-md-1"> <span><b>: </b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.businessModel}}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Payer Name</b></span></div>
                                  <div class="col-md-1"> <span><b>:</b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.payerName }}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Created By User</b></span></div>
                                  <div class="col-md-1"> <span><b>:</b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.credtedByUser }}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Opportunity Description</b></span></div>
                                  <div class="col-md-1"> <span><b>:</b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.opportunityDesc }}</span></div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Released On</b></span></div>
                                  <div class="col-md-1"><span><b>:</b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.releasedOn }}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Evaluated </b></span></div>
                                  <div class="col-md-1"> <span><b>: </b></span></div>
                                  <div class="col-md-7"><span>{{creditCheck.evaluated }}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Duration (Months)</b></span></div>
                                  <div class="col-md-1"> <span><b>:</b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.durationInMonth }}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Payment Term ( Payer)</b></span></div>
                                  <div class="col-md-1"> <span><b>:</b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.paymentTerms }}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Blocked Time</b></span></div>
                                  <div class="col-md-1"> <span><b>:</b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.blockedTime }}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Released Time</b></span></div>
                                  <div class="col-md-1"> <span><b>:</b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.releasedTime }}</span></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4" style="margin-bottom: 7px"><span> <b>Contract Account ID</b></span></div>
                                  <div class="col-md-1"> <span><b>:</b></span></div>
                                  <div class="col-md-7"> <span>{{creditCheck.contractAccountId }}</span></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <ng-container *ngIf="!creditCheckList || creditCheckList.length === 0">
                <div class="row"> 
                  <div class="col-lg-12"> 
                    <div class="row"> 
                      <div class="col-md-12"> 
                        <p class="text-center empty-table-message">There are no credit check to display.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>